module.exports = __webpack_public_path__ + "assets/debian-linux.f455f2a5.svg";